import { Tabs as ReachTabs } from '@reach/tabs';
export var Tabs = ReachTabs;
export default Tabs;